import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { createStyles, IconButton, InputAdornment, TextField, WithStyles, withStyles } from '@material-ui/core';
import { TextFieldProps } from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import classnames from 'classnames';

const styles = () =>
  createStyles({
    inputDefault: {
      height: '38px !important',
    },
    inputSmall: {
      height: '35px !important',
    },
  });

const messages = defineMessages({
  placeholder: {
    id: 'embeds.components.TextFieldSearch.placeholder',
    defaultMessage: 'Search',
  },
});

export interface TextFieldSearchProps extends Omit<TextFieldProps, 'classes' | 'onChange'>, WithStyles<typeof styles> {
  size?: 'default' | 'small';
  onChange: (v: string) => void;
}

const TextFieldSearchComponent: React.FC<TextFieldSearchProps> = ({
  classes,
  size = 'default',
  onChange,
  InputProps,
  ...rest
}) => {
  const { formatMessage } = useIntl();

  return (
    <TextField
      InputProps={{
        classes: {
          input: classnames({
            [classes.inputDefault]: size === 'default',
            [classes.inputSmall]: size === 'small',
          }),
        },
        ...InputProps,
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize={size === 'small' ? 'small' : undefined} />
          </InputAdornment>
        ),
        endAdornment: (
          <>
            <InputAdornment position="end">
              {!!rest.value && (
                <IconButton onClick={() => onChange('')}>
                  <CloseIcon fontSize={size === 'small' ? 'small' : undefined} />
                </IconButton>
              )}
            </InputAdornment>
            {InputProps && InputProps.endAdornment && <>{InputProps.endAdornment}</>}
          </>
        ),
      }}
      placeholder={formatMessage(messages.placeholder)}
      onChange={(event: any) => onChange(event.target.value)}
      {...rest}
    />
  );
};

export const TextFieldSearch = withStyles(styles)(TextFieldSearchComponent);
